<template>
  <div class="enterprise-content">
    <p class="title">Filter</p>
    <div :class="[showAll ? 'flexC' : 'flexR' , 'industry']">
      <div class="w40 formateAlign">
        <span class="text-label">Industry:</span>
        <el-select v-model="selectedIndustry" filterable placeholder="Please enter the industry you want to add"
                   size="mini" class="industrySelect">
          <el-option v-for="i in $parent.$parent.$parent.$parent.paramForm.article.industries" :key="i" :label="i"
                     :value="i"/>
        </el-select>
        <el-button icon="el-icon-plus icon-plus" size="mini" type="primary" @click="handleInputConfirm"/>
      </div>
      <div v-if="showAll && $parent.$parent.$parent.$parent.data.article.industries.length > 0 " class="enterprise">
        <el-tag v-for="i in $parent.$parent.$parent.$parent.data.article.industries" :key="i"
                :disable-transitions="false" closable @close="industryClose(i)">
          {{ i }}
        </el-tag>
      </div>
      <div class="w40 formateAlign">
        <span class="text-label">Enterprise:</span>
        <el-autocomplete v-model="selectedCompany" :fetch-suggestions="fetchSuggestions"
                         class="inline-input industrySelect"
                         placeholder="Please enter the enterprise you want to add" size="mini"/>
        <el-button icon="el-icon-plus icon-plus" size="mini" type="primary" @click="enterpriseInputConfirm"/>
      </div>
      <div v-if="showAll && $parent.$parent.$parent.$parent.data.article.companies.length > 0" class="enterprise">
        <el-tag v-for="i in $parent.$parent.$parent.$parent.data.article.companies" :key="i"
                :disable-transitions="false" closable @close="enterpriseClose(i)">
          {{ i }}
        </el-tag>
      </div>
    </div>
    <div :class="[showAll ? 'flexC' : 'flexR' , 'industry']">
      <div :class="[showAll ? '' : 'w34' , 'industry']">
        <div class="regional formateAlign">
          <span class="text-label">Nation:</span>
          <el-select v-model="selectCountry" filterable placeholder="Please enter the country you want to add"
                     size="mini" class="industrySelect">
            <el-option v-for="i in $parent.$parent.$parent.$parent.paramForm.article.countries" :key="i" :label="i"
                       :value="i"/>
          </el-select>
          <el-button icon="el-icon-plus icon-plus" size="mini" type="primary" @click="countryInputConfirm"/>
          <div v-if="showAll && $parent.$parent.$parent.$parent.data.article.mediaCountries.length > 0" class="enterprise">
            <el-tag v-for="i in $parent.$parent.$parent.$parent.data.article.mediaCountries" :key="i"
                    :disable-transitions="false" closable @close="countryClose(i)">{{ i }}
            </el-tag>
          </div>
        </div>

      </div>
      <div :class="[showAll ? '' : 'w64' , 'industry']">
        <div class="regional marR formateAlign">
          <span class="text-label">Time:</span>
          <el-date-picker v-model="$parent.$parent.$parent.$parent.data.article.pubTime"
                          :default-time="['00:00:00', '23:59:59']"
                          size="mini"
                          :picker-options="pickerOptions" range-separator="-" class="industrySelect"
                          type="daterange" :clearable="false"/>
        </div>
        <!--        <div class="regional">
                  <span class="text-label">Article source:</span>
                  <el-select v-model="source" placeholder="" class="industrySelect">
                    <el-option v-for="item in sources" :key="item" :label="item" :value="item"/>
                  </el-select>
                </div>-->
      </div>
    </div>
    <el-button class="showBtn" round @click="pick">
      <p>{{ showAll ? 'Pack Up' : 'View Details' }}</p>
      <p><i :class="showAll ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i></p>
    </el-button>
  </div>
</template>

<script>
import request from "@/views/brand/utils/request";

export default {
  name: "enterpriseSearch",
  data() {
    return {
      selectedIndustry: '',
      selectedCompany: '',
      selectCountry:'',
      showAll: false,
      source: 'All',
      sources: ['All'],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date().setHours(23, 59, 59, 999)
        },
        shortcuts: [{
          text: '最近7天',
          onClick(picker) {
            const start = new Date(new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * 6)
            const end = new Date(new Date().setHours(23, 59, 59, 999))
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近15天',
          onClick(picker) {
            const start = new Date(new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * 14)
            const end = new Date(new Date().setHours(23, 59, 59, 999))
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const start = new Date(new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * 29)
            const end = new Date(new Date().setHours(23, 59, 59, 999))
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  methods: {
    handleInputConfirm() {
      if (this.selectedIndustry) {
        if (this.$parent.$parent.$parent.$parent.data.article.industries.indexOf(this.selectedIndustry) < 0) {
          this.$parent.$parent.$parent.$parent.data.article.industries.push(this.selectedIndustry)
          this.selectedIndustry = ''
        } else {
          this.$message.warning('The industry already exists')
        }
      } else {
        this.$message.warning('Please select industry')
      }
    },
    enterpriseInputConfirm() {
      if (this.selectedCompany) {
        if (this.$parent.$parent.$parent.$parent.data.article.companies.indexOf(this.selectedCompany) < 0) {
          this.$parent.$parent.$parent.$parent.data.article.companies.push(this.selectedCompany)
          this.selectedCompany = ''
        } else {
          this.$message.warning('The enterprise already exists')
        }
      } else {
        this.$message.warning('Please select enterprise')
      }
    },
    industryClose(tag) {
      this.$parent.$parent.$parent.$parent.data.article.industries.splice(this.$parent.$parent.$parent.$parent.data.article.industries.indexOf(tag), 1);
    },
    enterpriseClose(tag) {
      this.$parent.$parent.$parent.$parent.data.article.companies.splice(this.$parent.$parent.$parent.$parent.data.article.companies.indexOf(tag), 1);
    },
    countryInputConfirm() {
      if (this.selectCountry) {
        if (this.$parent.$parent.$parent.$parent.data.article.mediaCountries.indexOf(this.selectCountry) < 0) {
          this.$parent.$parent.$parent.$parent.data.article.mediaCountries.push(this.selectCountry)
          this.selectCountry = ''
        } else {
          this.$message.warning('The country already exists')
        }
      } else {
        this.$message.warning('Please select country')
      }
    },
    countryClose(tag) {
      this.$parent.$parent.$parent.$parent.data.article.mediaCountries.splice(this.$parent.$parent.$parent.$parent.data.article.mediaCountries.indexOf(tag), 1);
    },
    pick() {
      this.showAll = !this.showAll;
    },
    fetchSuggestions(queryString, callback) {
      const data = {company: queryString}
      request({data, method: 'post', url: '/api/client/chinaEnterprise/searchCompany'}).then(result => {
        if (result.data.rows) {
          result.data.pageData = result.data.rows
          result.data.totalRecords = result.data.total
        }
        const enterpriseInits = []
        for (let i = 0; i < result.data.pageData.length; i++) {
          const bean = result.data.pageData[i];
          if (this.$parent.$parent.$parent.$parent.data.article.companies.indexOf(bean.englishName) < 0) {
            enterpriseInits.push({value: bean.englishName})
          }
        }
        callback(enterpriseInits)
      })
    }
  }
}
</script>

<style scoped>
.enterprise-content {
  text-align: left;
  position: relative;
}

.industry {
  display: flex;
}

.flexC {
  flex-direction: column;
}

.flexR {
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.w40 {
  width: 45%;
  margin-top: 20px;
}

.w34 {
  width: 45%;
}

.w64 {
  /*width: 64%;*/
}

.marR {
  margin-right: 20px;
}

.enterprise {
  margin-left: 120px;
  /*margin-bottom: 30px;*/
}

.enterprise-content .title {
  font-weight: bold;
  color: #2f8eff;
  text-align: left;
  padding-bottom: 20px;
  border-bottom: 1px solid #d8d8d8;
  margin-bottom: 20px;
}

.enterprise-content .text-label {
  font-size: 14px;
  color: #333333;
  font-family: "微软雅黑 Regular", 微软雅黑;
  font-weight: 400;
  font-style: normal;
  text-align: left;
  line-height: 28px;
  margin-right: 20px;
}

.enterprise-content .el-input {
  margin-right: 10px;
  width: 58%;
}

.enterprise-content .icon-plus {
  font-weight: bold;
}

.enterprise-content .el-tag {
  margin-right: 10px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  color: #7F7F7F;
  height: 28px;
  line-height: 26px;
  border-radius: 12px;
  margin-top: 16px;
}

.regional {
  margin-top: 20px;
}

.industry .el-select {
  margin-right: 10px;
}

.industry .industrySelect {
  margin-right: 10px;
}

.industrySelect {
  width: 300px;
}

.enterprise-content .showBtn {
  color: #2f8eff;
  font-size: 12px;
  font-weight: bold;
  position: absolute;
  bottom: -50px;
  left: 45%;

  border-top: none;
  border-left: none;
  border-right: none;
  /*border-bottom: 1px solid rgb(0 0 0 / 35%);*/
  box-shadow: rgb(205 207 210) 0px 4px 2px -2px;
}

.enterprise-content .showBtn,.el-button:hover {
  background-color: white;
}

.enterprise-content .el-button.is-round {
  padding: 4px 40px;
}

.formateAlign .text-label{
  float: left;
  width: 100px;
}


</style>
